import TouchspinContainer from "../../../../../Components/Forms&Table/Forms/FormWidgets/Touchspin/TouchspinContainer";

const Touchspin = () => {
  return <TouchspinContainer />;
};

export default Touchspin;
